/* eslint-disable jira/filename-case */
export const DB_NAME = 'jpd-store';
export const DB_VERSION = 1;
export const STORE_NAME = 'project-key-to-id-mapping';
export const INDEXEDDB_TIMEOUT_MS = 1000;
export const CACHE_TTL_MS = 5000;
